export enum CatExpertRouterLink {
  Login = "login",

  Home = "home",

  Studio = "studio",

  Create = "create",

  Assortment = "assortment",

  SpaceAssortment = "space-assortment",

  ClusteringInsights = "clustering-insights",

  Clustering = "clustering",

  DataExploration = "data-exploration",

  Pho = "pho",

  Edit = "edit",

  Eda = "eda",

  Experiments = "experiments",

  Nesting = "nesting",

  LevelZero = "level-zero",

  Simulation = "simulation",

  Optimization = "optimization",

  Settings = "settings",

  SkuFunnel = "sku-funnel",

  ClusterPlanoOverview = "cluster-plano-overview",

  DynamicNesting = "dynamic-nesting",

  Voting = "voting",

  Vote = "vote",

  LogisticsFramework = "logistics-framework",

  ProjectDetails = "project-details",

  GeneratePublish = "generate-publish",

  PlanogramDashboard = "plano-dashboard",

  Planogram = "planogram",

  // planogram v3 routes
  PlanogramV3 = "v3",
  Grid = "grid",
  Segment = "space",
  Product = "product",

  Dashboard = "global-dashboard",

  // Space Plano Create Flow Routes

  Cluster = "cluster",

  CreatePlan = "create-plano",

  UploadMappingFile = "upload-mapping-file",

  ConfigDynamicNesting = "configure-dynamic-nesting",

  AssortmentSummary = "assortment-summary",

  SpacePlanogram = "space-planogram",

  ClassicPlanogram = "classic-planogram",

  CustomizePDFDashboard = "pdf-template-dashboard",

  Bulk = "bulk",

  BulkUpload = "bulk-upload",

  BulkUploadImage = "bulk-upload-image",

  CreateBulkImport = "create-bulk-import",

  BulkEdit = "edit",

  BulkEditResult = "result",

  Shared = "shared",

  Folders = "folders",

  ProductLibrary = "product-library",

  Remediation = "remediation",

  Export = "export",

  DashboardView = "dashboard",

  DashboardLanding = "landing",

  DashboardStoreView = "store-wise-view",

  DashboardCountryView = "country-wise-view",

  AiImagery = "ai-imagery",

  NewChat = "chat",

  AiLibrary = "library",

  AiBulkGenerate = "bulk-generate",

  SkuSync = "sku-sync",
  
  SkuAttributeConfiguration = "sku-attribute-configuration",

  SyncSKU = "sync-sku",

  Libraries = "libraries",

  Landing = "landing",

  FixtureLibrary = "fixture-library",

  AddNewFixture = "add-new-fixture",

  FixtureAssignments = "fixture-assignments",

  FixtureNameConfig = "fixture-name-configuration",

  ValidateActiveFixtures = "validate-active-fixtures",

  FixtureBulkEdit = "fixture-bulk-edit",

  StoreLibrary = "store-library",

  StoreBulkEdit = "store-bulk-edit",

  StoreBulkUpload = "store-bulk-upload",

  Fixture = "fixture",

  KA = "ka",
}
